'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

import { scrollWindowToTopSmooth } from '@/shared/academy.utils'

export function ScrollToTopOnRouteChange() {
  const pathname = usePathname()

  useEffect(() => {
    scrollWindowToTopSmooth()
  }, [pathname])

  return null
}
